import { useForm, zodResolver } from "@mantine/form";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { getUser, postLogin } from "src/common/api";
import { loginSchema } from "src/common/schemas";
import { Button, Card, Header, TextInput, Typography } from "src/components";
import { SvgLogo as Logo } from "src/components/assets";

export const Login = () => {
  const location: any = useLocation();
  const from =
    // REVIEW should this behavior be configurable or kept?
    // Note to save both intended path and query string
    location.state?.from?.pathname + location.state?.from?.search || "/houses";
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const form = useForm({
    schema: zodResolver(loginSchema),
    initialValues: {
      email: "",
      password: "",
    },
  });

  const [loginError, setLoginError] = useState<string | number>();
  const { mutate: submitPostLogin, status: rqStatus } = useMutation(postLogin, {
    onSuccess: async (data) => {
      // TODO do proper error ux
      if (data.rn > 7) {
        return setLoginError(401);
      }
      sessionStorage.setItem("token", data.access_token);
      const user = await getUser({ userId: data.id, token: data.access_token });
      await queryClient.setQueryData("userAuth", user);

      navigate(from, { replace: true });
    },
    onError: (error: any) => {
      setLoginError(error.request.status);
    },
  });

  const renderError = () =>
    // TODO handle other errors, base on status code (ej. 500, etc), or default case
    loginError === 401 && (
      <Typography className="text-center" state="error">
        Invalid email or password
      </Typography>
    );

  return (
    <>
      <Header logo={<Logo height={"40%"} width={"40%"} />} />

      <form
        className="grid h-[90%] place-items-center"
        // TODO make onSubmit loader, perhaps use the useMutation hook
        onSubmit={form.onSubmit((credentials) => {
          submitPostLogin(credentials);
        })}
      >
        <Card className="flex w-1/2 flex-col gap-4">
          <Typography type="header" state="info" fontState="bold">
            Welcome back manager!
          </Typography>

          <TextInput
            placeholder="Email"
            type="email"
            {...form.getInputProps("email")}
          ></TextInput>
          <TextInput
            placeholder="Password"
            type="password"
            {...form.getInputProps("password")}
          ></TextInput>

          {renderError()}

          <Button loading={rqStatus === "loading"} text="Login" type="submit" />
          {process.env.NODE_ENV === "development" &&
            JSON.stringify({
              email: "manager@sesam.enterprises",
              password: "sesam4ever",
            })}
        </Card>
      </form>
    </>
  );
};
